import { jsx as s } from "react/jsx-runtime";
const o = {
  var: "_var_1wuj2_1"
};
function n({ pluralize: t, children: a }) {
  const r = t || t === 0 ? { "data-pluralize": t } : {};
  return /* @__PURE__ */ s("var", { className: o.var, ...r, children: a });
}
export {
  n as default
};
